export default new (class {
    constructor() {
        const id = decodeURIComponent(location.hash).substring(1);
        const anchor = document.getElementById(id);

        if (anchor) {
            window.addEventListener('load', () => {
                this.scrollTo(anchor);
            })
        }

        document.body.addEventListener('click', (e) => {
            const link = e.target.closest('a[href]')
            if (!link) return;

            const linkUrl = new URL(link.href);
            if (linkUrl.pathname != location.pathname) return;

            const hash = decodeURIComponent(linkUrl.hash);
            if (!hash) return

            const anchor = document.getElementById(hash.substring(1));
            if (!anchor) return;

            e.preventDefault();
            location.hash = hash;
            this.scrollTo(anchor);
        })
    }

    scrollTo(el) {
        const stickyHeader = document.querySelector('.header-sticky');
        const offset = stickyHeader?.clientHeight ?? 0;
        if (offset) {
            window.scrollTo({
                top: el.getBoundingClientRect().top + window.pageYOffset - offset
            });
        }
    }
})();
